<div>
  <div>
    An S3 bucket already exists with name "{{ recoveryBucketName }}". Please configure a custom recovery bucket suffix
    for this bucket below, or configure an alternate
    <a href="{{ accountResourceConfigUrl }}">account-level default suffix</a>, then try again.
  </div>

  <form [formGroup]="configFormModel" (ngSubmit)="saveClick()" class="form-controls">
    <div class="flex-center-row control-header">
      <input
        type="text"
        formControlName="recoveryBucketSuffix"
        [placeholder]="defaultSuffix"
        class="arpio-input"
        minlength="2"
        maxlength="12"
      />
      <button type="submit" class="arpio-button margin-left" [disabled]="!validConfig">
        <ng-container [ngSwitch]="saveStatus">
          <i *ngSwitchCase="'saving'" class="fa-solid fa-spinner fa-spin"></i>
          <i *ngSwitchCase="'saved'" class="fa-utility fa-semibold fa-check"></i>
          <ng-container *ngSwitchDefault>SAVE</ng-container>
        </ng-container>
      </button>
    </div>
    <div class="new-bucket-name">
      <span class="new-bucket-name-label">New Recovery Bucket Name:</span>
      {{ newRecoveryBucketName }}
    </div>
  </form>
</div>
